module.exports = __webpack_public_path__ + "media/flags/mh-31263480.svg";